
/* injects from baggage-loader */

'use strict';

import dialogAlertTpl from './alert.html';
import DialogAlertController from './alert.controller';

export default class DialogAlertComponent {
	constructor() {
		this.templateUrl = dialogAlertTpl;
		this.controller = DialogAlertController;
		this.bindings = {
			modalInstance: "=",
			resolve: "="
		};
	}
}


// WEBPACK FOOTER //
// ./src/app/components/dialogs/alert/alert.component.js